import { Route } from 'react-router-dom'
import { ErrorContent } from '../globalComponents/ErrorContent'
import { CostChangeInsightsPage } from '../views/CostChangeInsights/CostChangeInsightsPage'
import { CostSearchPage } from '../views/CostSearch/CostSearchPage'
import { UnfoundRoute } from '../globalComponents/UnfoundRoute'
import { UnauthorizedPage } from '../globalComponents/UnauthorizedPage'
import { SpreadsheetDashboard } from '../views/SpreadsheetDashboard/SpreadsheetDashboard'
import { ManageCustomLocationGroupsPage } from '../views/ManageCustomLocationGroups/ManageCustomLocationGroupsPage'
import { SavedView } from '../views/SavedView/SavedView'
import { HomePage } from '../views/HomePage/HomePage'
import { ProtectedElement } from '@praxis/component-auth'
import apiConfig from '../globalConfig/apiConfig'
import { CostChangeInsightsPageProvider } from '../views/CostChangeInsights/pageState'
import { ManageNotificationsPage } from '../views/ManageNotifications/ManageNotificationsPage'
import { COST_CHANGE_INSIGHTS_SUBMENU_DETAILS_MAP } from '../globalConfig/constants'

export const routes = (
  <>
    <Route
      path="/"
      element={
        <ProtectedElement
          allowed={apiConfig.accessControlGroups}
          renderUnauthorized={() => <UnauthorizedPage />}
        >
          <HomePage />
        </ProtectedElement>
      }
      errorElement={<ErrorContent />}
    ></Route>
    {Object.keys(COST_CHANGE_INSIGHTS_SUBMENU_DETAILS_MAP).map((key) => (
      <Route
        path={key}
        element={
          <ProtectedElement
            allowed={apiConfig.accessControlGroups}
            renderUnauthorized={() => <UnauthorizedPage />}
          >
            <CostChangeInsightsPageProvider key={key}>
              <CostChangeInsightsPage
                key={key}
                highlightedFieldKeyNames={
                  COST_CHANGE_INSIGHTS_SUBMENU_DETAILS_MAP[key]
                    .HIGHLIGHTED_FIELDS
                }
                submenuText={
                  COST_CHANGE_INSIGHTS_SUBMENU_DETAILS_MAP[key].SUBMENU_TEXT
                }
                submenuName={
                  COST_CHANGE_INSIGHTS_SUBMENU_DETAILS_MAP[key].SUBMENU_NAME
                }
              />
            </CostChangeInsightsPageProvider>
          </ProtectedElement>
        }
        errorElement={<ErrorContent />}
      ></Route>
    ))}
    <Route
      path="/cost-search"
      element={
        <ProtectedElement
          allowed={apiConfig.accessControlGroups}
          renderUnauthorized={() => <UnauthorizedPage />}
        >
          <CostSearchPage />
        </ProtectedElement>
      }
      errorElement={<ErrorContent />}
    ></Route>
    <Route
      path="/saved-view/:savedViewId"
      element={
        <ProtectedElement
          allowed={apiConfig.accessControlGroups}
          renderUnauthorized={() => <UnauthorizedPage />}
        >
          <SavedView />
        </ProtectedElement>
      }
      errorElement={<ErrorContent />}
    ></Route>
    <Route
      path="/spreadsheet-dashboard"
      element={
        <ProtectedElement
          allowed={apiConfig.accessControlGroups}
          renderUnauthorized={() => <UnauthorizedPage />}
        >
          <SpreadsheetDashboard />
        </ProtectedElement>
      }
      errorElement={<ErrorContent />}
    ></Route>
    <Route
      path="/manage-custom-location-groups"
      element={
        <ProtectedElement
          allowed={apiConfig.accessControlGroups}
          renderUnauthorized={() => <UnauthorizedPage />}
        >
          <ManageCustomLocationGroupsPage />
        </ProtectedElement>
      }
      errorElement={<ErrorContent />}
    ></Route>
    <Route
      path="/manage-notifications"
      element={
        <ProtectedElement
          allowed={apiConfig.accessControlGroups}
          renderUnauthorized={() => <UnauthorizedPage />}
        >
          <ManageNotificationsPage />
        </ProtectedElement>
      }
      errorElement={<ErrorContent />}
    ></Route>
    <Route
      path="/unauthorized-resource"
      element={<UnauthorizedPage />}
      errorElement={<ErrorContent />}
    ></Route>
    <Route
      path="*"
      element={<UnfoundRoute />}
      errorElement={<ErrorContent />}
    ></Route>
  </>
)
